import React from 'react';
import './app.scss';

import MainPage from '../../pages/main-page/main-page';

function App() {
  return (
    <div className="app">
      <MainPage />
    </div>
  );
}

export default App;
